import React from 'react';
import Button from '../../components/Button';
import ui from './ProductAdminDashboard.module.css';
import { FilterIcon } from './ProductAdminIcons';

// Activity period selector shared by the product-admin pages
export default function ReportFilters({ filters, setFilters, onApply, loading }) {
  return (
    <section className={`${ui.panel} ${ui.toolbar}`}>
      <label>
        Activity period
        <select value={filters.period} onChange={e => setFilters({ ...filters, period: e.target.value })}>
          <option value="day">Today</option>
          <option value="month">This month</option>
          <option value="year">This year</option>
          <option value="all">All time</option>
          <option value="custom">Custom range</option>
        </select>
      </label>
      {filters.period === 'custom' && <>
        <label>From<input type="date" value={filters.from} onChange={e => setFilters({ ...filters, from: e.target.value })} /></label>
        <label>To<input type="date" value={filters.to} onChange={e => setFilters({ ...filters, to: e.target.value })} /></label>
      </>}
      <Button onClick={onApply} loading={loading}>
        <span className={ui.filterButtonContent}><FilterIcon size={16} /> Apply Filter</span>
      </Button>
    </section>
  );
}
